import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {ShippingInstructionService} from '../../services'

const ShippingInstructionPrint = () => {
    const {id} = useParams();
    const [content, setContent] = useState('');
    useEffect(() => {
        ShippingInstructionService.getOutput(id).then((response) => {
            setContent(response.data);
        });
    }, [id]);


    return (
        <div style={{textAlign: 'left'}}>
            <div dangerouslySetInnerHTML={{__html: content}}></div>
        </div>
    );
};

export default ShippingInstructionPrint;
